import { createElement } from './util';

export interface AutocompleteItem {
	label: string;
	sublabel?: string;
	image?: string;
}

export type AutocompleteDataFetcher = (query: string) => Promise<AutocompleteItem[]>;

export function activateAutocompleteField(id: string, fetch: AutocompleteDataFetcher) {
	const autocompleteElement = document.getElementById(id);
	if (autocompleteElement) {
		const autocompleteContainer = autocompleteElement.querySelector('.autocomplete-item-container');
		const autocompleteInput = autocompleteElement.querySelector('input.autocomplete-input');

		if (autocompleteContainer && autocompleteInput) {
			const width = getComputedStyle(autocompleteInput).width;
			(autocompleteContainer as HTMLDivElement).style.width = width;
		}

		let active = false;
		let selectedIndex = -1;
		let items: AutocompleteItem[] = [];
		let prev = '';

		function isVisible() {
			return active && items.length > 0;
		}

		function deactivate() {
			active = false;
			if (autocompleteInput && prev !== '') {
				(autocompleteInput as HTMLInputElement).value = prev;
				prev = '';
			}
		}

		function clear() {
			selectedIndex = -1;
		}

		function overwriteInput() {
			if (autocompleteInput) {
				if (selectedIndex > -1) {
					const item = items[selectedIndex];
					if (item) {
						if (prev === '') {
							prev = (autocompleteInput as HTMLInputElement).value;
						}
						(autocompleteInput as HTMLInputElement).value = item.label;
					}
				}
			}
		}

		function handleHover(index: number) {
			selectedIndex = index;
			render();
		}

		function handleSelect(index: number) {
			console.log('handleSelect: index: ', index);
			const item = items[index];
			if (item && autocompleteInput) {
				console.log('handleSelect: check');
				(autocompleteInput as HTMLInputElement).value = item.label;
				clear();
			}
			render();
		}

		function render() {
			if (autocompleteContainer) {
				autocompleteContainer.innerHTML = '';

				if (isVisible()) {
					autocompleteContainer.classList.remove('hidden');

					items.forEach((item, i) => {
						const autocompleteItem = createElement('div', 'autocomplete-item');
						if (i === selectedIndex) {
							autocompleteItem.classList.add('active');
						}

						autocompleteItem.addEventListener('mouseup', () => handleSelect(i));
						autocompleteItem.addEventListener('mouseover', () => handleHover(i));

						if (item.image) {
							const left = createElement('figure', 'autocomplete-item-left');
							left.innerHTML = `
								<p class="image">
									<img src="${item.image}" />
								</p>`;
							autocompleteItem.appendChild(left);
						}

						const content = createElement('div', 'autocomplete-item-content');
						const label = createElement('div', 'label');
						label.textContent = item.label;
						content.appendChild(label);

						if (item.sublabel) {
							const sublabel = createElement('div', 'sublabel');
							sublabel.textContent = item.sublabel;
							content.appendChild(label);
						}

						autocompleteItem.appendChild(content);
						autocompleteContainer.appendChild(autocompleteItem);
					});
				} else {
					autocompleteContainer.classList.add('hidden');
				}
			}
		}

		function handleFocus() {
			active = true;
			render();
		}

		function handleBlur() {
			setTimeout(() => {
				deactivate();
				render();
			}, 200);
		}

		async function handleInput(event: Event) {
			selectedIndex = -1;
			prev = '';
			active = true;

			const value = (event.target as HTMLInputElement).value;

			try {
				const response = await fetch(value);
				if (response) {
					items = response;
				}
			} catch (err) {
				console.error(err);
			}

			render();
		}

		function handleKeyup(event: KeyboardEvent) {
			switch (event.code) {
				case 'ArrowDown':
					if (selectedIndex < items.length - 1) {
						selectedIndex++;
						overwriteInput();
					}
					break;
				case 'ArrowUp':
					if (selectedIndex > 0) {
						selectedIndex--;
						overwriteInput();
					}
					break;
				case 'Escape':
					deactivate();
					break;
				case 'Enter':
					clear();
					break;
			}

			render();
			return false;
		}

		if (autocompleteInput) {
			(autocompleteInput as HTMLInputElement).addEventListener('focus', handleFocus);
			(autocompleteInput as HTMLInputElement).addEventListener('blur', handleBlur);
			(autocompleteInput as HTMLInputElement).addEventListener('input', handleInput);
			(autocompleteInput as HTMLInputElement).addEventListener('keyup', handleKeyup);
		}

		render();
	}
}